import { mpEventInfo } from '@/constant'
import maxios from '@/utils/axios/maxios'

// 신고 API
const bugReportApi = {
  // 문제 신고하기
  postErrorReportCustomProblem: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/problem`, data, {
      params: { mp_event_name: mpEventInfo.문제신고 },
    })
  },
  // 시중문제 신고하기
  postErrorReportPublicProblem: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/public-problem`, data, {
      params: { mp_event_name: mpEventInfo.시중문제신고 },
    })
  },
  // 유형 신고하기
  postErrorReportConcept: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/concept`, data, {
      params: { mp_event_name: mpEventInfo.유형신고 },
    })
  },
  postErrorReportLittleChapter: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/little-chapter`, data, {
      params: { mp_event_name: mpEventInfo.유형신고 },
    })
  },

  // 학습지 신고하기
  postErrorReportWorksheet: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/worksheet`, data, {
      params: { mp_event_name: mpEventInfo.학습지신고 },
    })
  },
}

export default bugReportApi
